// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap_3CG0qewn"};